import { getData, postData, putData, deleteData } from '../services/apiService';
import { User } from '../types/User';
import { CreateUserRoleRequest, UpdateUserRoleRequest, UserRole } from '../types/UserRole';

// Get all users
export const getRolesByUserId = async (user_id: string): Promise<UserRole[]> => {
  try {
    const response = await getData(`/users/${user_id}/roles`, {});
    return response.data as UserRole[];
  } catch (error) {
    console.error('Failed to fetch user roles:', error);
  }
  return [];
};


// Get all users
export const getUserRoles = async (): Promise<UserRole[]> => {
  try {
    const response = await getData(`/user-roles`, {});
    return response.data as UserRole[];
  } catch (error) {
    console.error('Failed to fetch user roles.', error);
  }
  return [];
};

export const deleteUserRole = async (user_role_id: string): Promise<void> => {
  try {
    const response = await deleteData(`/user-roles/${user_role_id}`, {});
    return;
  } catch (error) {
    console.error('Failed to delete user role', error);
  }
  return;
};


export const updateUserRole = async (user_role_id: string, update_request: UpdateUserRoleRequest): Promise<boolean> => {
  try {
    const response = await putData(`/user-roles/${user_role_id}`, update_request);
    return response.success as boolean;
  } catch (error) {
    console.error('Failed to delete user role', error);
  }
  return false;
};

export const createUserRole = async (role_request: CreateUserRoleRequest): Promise<UserRole | null> => {
  try {
    const response = await postData(`/user-roles`, role_request);
    return response.data as UserRole;
  } catch (error) {
    console.error('Failed to delete user role', error);
  }
  return null;
};